<template>
  <div class="public-template">
    <div class="public-content">
      <div class="container">
        <h1>Oops!</h1>
        <p>
          We can't seem to find the page you are looking for. 404 Page Not Found.
        </p>
        <p>
          Try checking the URL for errors or use one of the links below.
        </p>
        <router-link class="btn btn-primary" :to="{name: 'dashboard'}">Dashboard</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notfound',
  props: {},
  data() {
    return {};
  },
};
</script>

<style scoped></style>
